import {
  foreignNationalOptions,
  yesNoDropdown
} from "../../../create-loan/constants/loanCreationDropDownValues";
import { CreditEventDropDown } from "../../../create-loan/form-components/LoanInformation";
import { ObjectType } from "../../../masterView/common";
import { thirtyYearCreditEvent } from "../../constants";

const firstName = {
  fieldName: "guarantorFirstName",
  backendKey: "guarantorFirstName",
  fieldLabel: "First Name",
  required: () => true,
  fieldType: (loanType: string) => "string",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please enter value",
  commentField: "customer.firstName",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const middleName = {
  fieldName: "guarantorMiddleName",
  backendKey: "guarantorMiddleName",
  fieldLabel: "Middle Name",
  required: () => false,
  fieldType: (loanType: string) => "string",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please enter value",
  commentField: "customer.middleName",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
}

const secondName = {
  fieldName: "guarantorLastName",
  backendKey: "guarantorLastName",
  fieldLabel: "Last Name",
  required: () => true,
  fieldType: (loanType: string) => "string",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please enter value",
  commentField: "customer.lastName",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const foreignNational = {
  fieldName: "foreignNationalString",
  backendKey: "foreignNationalString",
  fieldLabel: "Foreign National Flag",
  required: () => true,
  fieldType: (loanType: string) => "dropDown",
  dropDownData: foreignNationalOptions.map((item) => ({
    value: item,
    label: item
  })),
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please select value",
  commentField: "customer.foreignNationalString",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const originalCreditScoreMedian = {
  fieldName: "creditScore",
  backendKey: "creditScore",
  fieldLabel: "Original Credit Score (Median)",
  required: (guarantorInfo: any) => {
    if (
      guarantorInfo?.foreignNationalString &&
      guarantorInfo?.foreignNationalString !== "Yes"
    ) {
      return true;
    }
    return false;
  },
  fieldType: (loanType: string) => "string",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please enter value",
  commentField: "originalCreditScoreMedian",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const originalCreditReportDate = {
  fieldName: "originalCreditReportDate",
  backendKey: "originalCreditReportDate",
  fieldLabel: "Original Credit Report Date",
  required: (guarantorInfo: any) => {
    if (
      guarantorInfo?.foreignNationalString &&
      guarantorInfo?.foreignNationalString !== "Yes"
    ) {
      return true;
    }
    return false;
  },
  fieldType: (loanType: string) => "date",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please select value",
  commentField: "originalCreditScoreReportDate",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const email = {
  fieldName: "guarantorEmail",
  backendKey: "guarantorEmail",
  fieldLabel: "Email",
  required: (guarantorInfo: any, borrowersData: any, loanStage: any) => guarantorInfo?.fundingType === "table_funding",
  fieldType: (loanType: string) => "string",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please select value",
  commentField: "customer.contactList[0].email",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const experience = {
  fieldName: "guarantorExperience",
  backendKey: "guarantorExperience",
  fieldLabel: "Experience",
  required: () => false,
  fieldType: (loanType: string) => "string",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please select value",
  commentField: "experience",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const experienceIn3To10Years = {
  fieldName: "experienceIn3To10Years",
  backendKey: "experienceIn3To10Years",
  fieldLabel: "Experience in the last 3 to 10 years",
  required: () => false,
  fieldType: (loanType: string) => "number",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please select value",
  commentField: "experienceIn3To10Years",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const ownerShipEntity = {
  fieldName: "pOEntity",
  backendKey: "pOEntity",
  fieldLabel: "% of Ownership of Entity",
  required: (data: ObjectType, borrowerInfoData: any) => {
    if (Array.isArray(borrowerInfoData)) {
      return borrowerInfoData?.find(
        (borrower: any) => borrower?.payload?.borrowerType === "Entity"
      );
    }
    return (
      borrowerInfoData?.payload?.borrowerInformation?.borrowerType === "Entity"
    );
  },
  fieldType: (loanType: string) => "percentageWithout100x",
  colSpan: 4,
  isVisible: () => true,
  errorMsg: "Please select value",
  commentField: "ownershipOfEntity",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const firstTimeHomeBuyer = {
  fieldName: "firstTimeHomeBuyer",
  fieldLabel: "First Time Home Buyer",
  backendKey: "firstTimeHomeBuyer",
  required: () => true,
  fieldType: (loanType: string) => "dropDown",
  dropDownData: yesNoDropdown.map((item) => ({ value: item, label: item })),
  colSpan: 4,
  isVisible: (data: any) => true,
  commentField: "firstTimeHomeBuyer",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const creditEvent = {
  fieldName: "creditEvent",
  backendKey: "creditEvent",
  editedLabelPath: "creditEvent",
  fieldLabel: "FC/SS/DIL/BK",
  required: (loanStage: any) => true,
  fieldType: (loanType: string) => "dropDown",
  dropDownData: thirtyYearCreditEvent || [],
  colSpan: 4,
  isVisible: (loanInformation: any) => true,
  fieldComponent: CreditEventDropDown,
  errorMsg: "Please select value",
  commentField: "customer.creditEvent",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const lastFcDate = {
  fieldName: "lastFcDate",
  backendKey: "lastFcDate",
  fieldLabel: "Last Foreclosure Date",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "date",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastFcDate",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable,
  hideClearIcon: (data: any) => true
};

const lastSsDate = {
  fieldName: "lastSsDate",
  backendKey: "lastSsDate",
  fieldLabel: "Last Short Sale Date",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "date",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastSsDate",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable,
  hideClearIcon: (data: any) => true
};

const lastDilDate = {
  fieldName: "lastDilDate",
  backendKey: "lastDilDate",
  fieldLabel: "Last Deeds in Lieu Date",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "date",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastDilDate",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable,
  hideClearIcon: (data: any) => true
};

const lastDelinquencyDate = {
  fieldName: "lastDelinquencyDate",
  backendKey: "lastDelinquencyDate",
  fieldLabel: "Last Delinquency Date",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "date",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastDelinquencyDate",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable,
  hideClearIcon: (data: any) => true
};

const lastBkDate = {
  fieldName: "lastBkDate",
  backendKey: "lastBkDate",
  fieldLabel: "Last Bankruptcy Date",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "date",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastBkDate",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable,
  hideClearIcon: (data: any) => true
};

const lastSsMonths = {
  fieldName: "lastSsMonths",
  backendKey: "lastSsMonths",
  fieldLabel: "Months Since Short Sale",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "string",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastSsMonths",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) => true
};

const lastDilMonths = {
  fieldName: "lastDilMonths",
  backendKey: "lastDilMonths",
  fieldLabel: "Months Since Deeds in Lieu",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "string",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastDilMonths",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) => true
};

const lastBkMonths = {
  fieldName: "lastBkMonths",
  backendKey: "lastBkMonths",
  fieldLabel: "Months Since Bankruptcy",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "string",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastBkMonths",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) => true
};

const lastFcMonths = {
  fieldName: "lastFcMonths",
  backendKey: "lastFcMonths",
  fieldLabel: "Months Since Foreclosure",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "string",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastFcMonths",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) => true
};

const lastDelinquencyMonths = {
  fieldName: "lastDelinquencyMonths",
  backendKey: "lastDelinquencyMonths",
  fieldLabel: "Months Since Delinquency",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: () => "string",
  colSpan: 3,
  isVisible: (data: any) => true,
  commentField: "customer.lastDelinquencyMonths",
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) => true
};

const billingAddress = {
  fieldName: "billingAddress",
  fieldLabel: "Guarantor Full Billing Address",
  backendKey: "addressLine1",
  required: (borrowerInfo: any, borrowersData: any, loanStage: any) => false,
  fieldType: (loanType: string) => "autocomplete",
  colSpan: 4,
  isVisible: (data: any) => true,
  commentField: `customer.addressList[0].addressLine1`,
  isViewMode: (isEvaluationPanelVisible: any, isEditable: any) =>
    isEvaluationPanelVisible && !isEditable
};

const prePostFields = [
  firstName,
  middleName,
  secondName,
  foreignNational,
  originalCreditScoreMedian,
  originalCreditReportDate,
  email,
  billingAddress,
  // experience,
  // experienceIn3To10Years,
  ownerShipEntity,
  creditEvent
];

const dscrPrePostFields = [
  firstName,
  secondName,
  foreignNational,
  originalCreditScoreMedian,
  originalCreditReportDate,
  email,
  billingAddress,
  experience,
  // experienceIn3To10Years,
  ownerShipEntity,
  creditEvent,
  firstTimeHomeBuyer
];

export const getGuarantorCreditEventFields = () => [
  lastFcDate,
  lastSsDate,
  lastDilDate,
  lastBkDate,
  lastFcMonths,
  lastSsMonths,
  lastDilMonths,
  lastBkMonths,
  lastDelinquencyDate,
  lastDelinquencyMonths
];

export const getGuarantorInformationFields = (
  loanStage: string,
  loanType: string
) => {
  switch (loanStage) {
    case "fes":
      return [];
    case "pre":
    case "post":
      return loanType === "BridgeLoan" ? prePostFields : dscrPrePostFields;
  }
};
